import { Button, Label, TextInput, Textarea } from 'flowbite-react';
import { useState } from 'react';

export type TransferFiatModalProps = {
  onConfirm: (params: { fiatAmount: number; comment?: string }) => void;
  onCancel: () => void;
};

export const TransferFiatModal = ({
  onConfirm,
  onCancel,
}: TransferFiatModalProps) => {
  const [fiatAmount, setFiatAmount] = useState<string>('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    setError(null);
    const amount = fiatAmount.trim()
      ? Number(fiatAmount.replace(/\s/g, ''))
      : NaN;
    if (Number.isNaN(amount) || amount <= 0) {
      setError('Введите корректную сумму');
      return;
    }
    onConfirm({ fiatAmount: amount, comment: comment.trim() || undefined });
  };

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="transfer-fiat-amount" className="mb-2 block">
          Сумма (RUB)
        </Label>
        <TextInput
          id="transfer-fiat-amount"
          type="text"
          placeholder="0"
          value={fiatAmount}
          onChange={(e) => setFiatAmount(e.target.value)}
          className="w-full"
        />
      </div>
      <div>
        <Label htmlFor="transfer-fiat-comment" className="mb-2 block">
          Комментарий
        </Label>
        <Textarea
          id="transfer-fiat-comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Необязательно"
          rows={3}
          className="w-full"
        />
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div className="flex gap-4 border-t border-gray-200 pt-4">
        <Button color="primary" onClick={handleSubmit}>
          Отправить
        </Button>
        <Button color="light" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
